import React from 'react';
import { MdEdit, MdDelete, MdEmail, MdPhoneAndroid } from 'react-icons/md';

const AlertasTable = ({ alertas, onEdit, onDelete }) => {
  const tiposLabels = {
    reservatorio: 'Reservatório',
    conexao: 'Conexão',
    canal_inativo: 'Canal Inativo',
    recuperacao_conexao: 'Recuperação - Conexão',
    recuperacao_canal: 'Recuperação - Canal'
  };

  const categoriasLabels = {
    monitoramento: 'Monitoramento',
    recuperacao: 'Recuperação'
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  if (!alertas || alertas.length === 0) {
    return (
      <div className="alertas-empty-state">
        <p>Nenhum alerta cadastrado. Use o botão Criar alerta acima para começar.</p>
      </div>
    );
  }

  return (
    <div className="alertas-table-wrapper">
      <table className="alertas-table">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Categoria</th>
            <th>Métodos</th>
            <th>Mensagem</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {alertas.map((alerta) => (
            <tr key={alerta.id}>
              <td className="alertas-td-tipo">
                <span className={`alertas-badge alertas-badge-${alerta.categoria}`}>
                  {tiposLabels[alerta.tipo] || alerta.tipo}
                </span>
              </td>
              <td>{categoriasLabels[alerta.categoria] || alerta.categoria}</td>
              <td>
                <div className="alertas-metodos">
                  {alerta.enviar_email && <span className="alertas-metodo-badge"><MdEmail className="alertas-metodo-icon" /> Email</span>}
                  {alerta.enviar_telegram && <span className="alertas-metodo-badge"><MdPhoneAndroid className="alertas-metodo-icon" /> Telegram</span>}
                </div>
              </td>
              <td className="alertas-td-mensagem" title={alerta.mensagem}>
                {truncateText(alerta.mensagem, 50)}
              </td>
              <td className="alertas-td-acoes">
                <button
                  className="alertas-btn-edit"
                  onClick={() => onEdit(alerta)}
                  title="Editar alerta"
                >
                  <MdEdit className="alertas-acoes-icon" />
                </button>
                <button
                  className="alertas-btn-delete"
                  onClick={() => onDelete(alerta.id)}
                  title="Deletar alerta"
                >
                  <MdDelete className="alertas-acoes-icon" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AlertasTable;
